import { useMemo } from 'react';

export default function useDefinitions() {
  return useMemo(() => ({
    entityName: 'Meta Field',
    entityNamePlural: 'Meta Fields',
    entityNameModule: 'settings',
    basePath: '/settings/meta-fields',
  }), [])
}
